import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react"
import reducer, { StoreState, initialState } from "./reducer"
import { StoreAction } from "../types/store"

interface StoreContext {
  stateShared: StoreState
  dispatchShared: Dispatch<StoreAction>
}

export const Store = createContext<StoreContext>({
  stateShared: initialState,
  dispatchShared: () => undefined,
})

export function useStoreShared(): StoreContext {
  return useContext(Store)
}

interface Props {
  children: ReactNode | ReactNode[]
}

export function StoreProviderShared({ children }: Props) {
  const [stateShared, dispatchShared] = useReducer(reducer, initialState)

  return <Store.Provider value={{ stateShared, dispatchShared }}>{children}</Store.Provider>
}
